export const getBannerLink = (link = "") => {
  if (!link || /[\\\\\s]/.test(link)) return "";
  if (link.startsWith("/") && !link.startsWith("//")) return link;
  try {
    const url = new URL(link);
    return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password ? link : "";
  } catch {
    return "";
  }
};


export const getBannerDestination = (banner) => {
  const link = getBannerLink(banner?.link);
  if (!banner?._id || !link.startsWith('/')) return link;
  const destination = new URL(link, 'https://website.example');
  if (destination.pathname !== '/signup') return link;
  destination.searchParams.set('competition', banner._id);
  return destination.pathname + destination.search + destination.hash;
};
